module.exports = __webpack_public_path__ + "img/VG.1561cbc1.png";